import React from "react";
import { Box, HStack, Popover, Portal, Text, Tooltip } from "@chakra-ui/react";
import { EMOJI_RATING_ITEMS } from "./EmojiRatingBar";

export function CompactEmojiRatingPicker({ value = "", onChange, isDisabled = false, ariaLabel = "Calificacion", items = EMOJI_RATING_ITEMS }) {
  const [open, setOpen] = React.useState(false);
  const normalizedValue = value == null || value === "" ? null : Number(value);
  const selected = items.find((it) => Number(it.value) === normalizedValue) ?? null;
  const tooltipLabel = selected?.label ?? "Sin calificacion";

  return (
    <Popover.Root open={open} onOpenChange={(e) => setOpen(e.open)} positioning={{ placement: "top", strategy: "fixed" }}>
      <Popover.Trigger asChild>
        <Box as="button" type="button" aria-label={ariaLabel} disabled={isDisabled} w="11" h="10" rounded="xl" borderWidth="0" bg="transparent" opacity={isDisabled ? 0.6 : 1} display="grid" placeItems="center" _hover={{ bg: "dashboard.bg.surfaceMuted" }} _focusVisible={{ outline: "2px solid", outlineColor: "dashboard.accent.border", outlineOffset: "2px" }}>
          <Tooltip.Root openDelay={0}>
            <Tooltip.Trigger asChild>
              <Text fontSize={selected ? "32px" : "xl"} lineHeight="1">{selected?.emoji ?? "\u2795"}</Text>
            </Tooltip.Trigger>
            <Tooltip.Positioner>
              <Tooltip.Content>{tooltipLabel}</Tooltip.Content>
            </Tooltip.Positioner>
          </Tooltip.Root>
        </Box>
      </Popover.Trigger>

      <Portal>
        <Popover.Positioner>
          <Popover.Content w="auto">
            <Popover.Body p="2">
              <HStack gap="1">
                {items.map((it) => (
                  <Tooltip.Root key={it.value} openDelay={0}>
                    <Tooltip.Trigger asChild>
                      <Box as="button" type="button" onClick={() => { onChange?.(String(it.value)); setOpen(false); }} w="10" h="10" rounded="xl" bg="transparent" borderWidth="0" display="grid" placeItems="center" transition="transform 120ms ease, background 120ms ease" transform={Number(it.value) === normalizedValue ? "scale(1.18)" : "scale(1)"} _hover={{ bg: "dashboard.bg.surfaceMuted", transform: "scale(1.12)" }}>
                        <Text fontSize={Number(it.value) === normalizedValue ? "30px" : "24px"} lineHeight="1">{it.emoji}</Text>
                      </Box>
                    </Tooltip.Trigger>
                    <Tooltip.Positioner>
                      <Tooltip.Content>{it.label}</Tooltip.Content>
                    </Tooltip.Positioner>
                  </Tooltip.Root>
                ))}
              </HStack>
            </Popover.Body>
          </Popover.Content>
        </Popover.Positioner>
      </Portal>
    </Popover.Root>
  );
}
